module.exports = __webpack_public_path__ + "img/rrd-logo-text.1d7b7f97.png";